module.exports = __webpack_public_path__ + "static/img/ys.22d3034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/修饰合成/ys.png
// module id = 5zSd
// module chunks = 1